// import pictures_json from '../../../assets/pictures.json';
import catalog_json from '../../../../assets/catalog.json';

import { Singleton } from '@denishussar/html5-game-engine';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { getRemoteConfig, getValue } from 'firebase/remote-config';
import { devShopConfig } from '../../Common/DevConfig';
import { IAlbumsLibraryData, IUserData } from './Contract';
import { LocalizationContents } from '../../LocalizationContents';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getFirebaseConfiguration } from '../../../env';

export interface ICloudDB {
    authWithEmail(email: string, password: string); //note: auto-create user if needed
    authWithToken(token: string);
}

@Singleton
export class FirebaseCloudDB implements ICloudDB {
    private remoteConfig: any;

    private app: FirebaseApp; //todo: refactor (temp decision)
    logEvent(eventName: string, eventParams: object = {}) { //todo: refactor (temp decision)
        return logEvent(getAnalytics(this.app), eventName, eventParams);
    }

    logEventPage(pageName: string, eventParams: object = {}) {
        return logEvent(getAnalytics(this.app), 'page_view', {
            page_title: pageName,
            page_location: pageName,
            ...eventParams
        })
    }

    constructor() {
        // const firebaseConfig = { //todo: send to .env or another config
        //     apiKey: 'AIzaSyAO4Xp-k8ep-3Q8zvnJWdP3_wNcRFX0AZM',
        //     authDomain: 'beaver-weaver-social-1.firebaseapp.com',
        //     projectId: 'beaver-weaver-social-1',
        //     storageBucket: 'beaver-weaver-social-1.appspot.com',
        //     messagingSenderId: '901826750472',
        //     appId: '1:901826750472:web:35202eb6c2e06a2954c9bd',
        //     measurementId: 'G-2M3L3TMB3S'
        // };
        const firebaseConfig = getFirebaseConfiguration()

        this.app = initializeApp(firebaseConfig);

        // init remoteConfig
        this.remoteConfig = getRemoteConfig();
        this.remoteConfig.defaultConfig = {
            ShopConfig: JSON.stringify(devShopConfig()), // TODO: fetch from remote
        };
        console.log('remoteConfig', this.remoteConfig);
    }


    public authWithToken(token: string) {
        signInWithCustomToken(getAuth(), token)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;
                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                // ...
            });
    }

    async authWithEmail(email: string, password: string) {

    }

    public getShopConfig() {
        return JSON.parse(getValue(this.remoteConfig, 'ShopConfig').asString());
    }

    public getAlbumsLibraryData(): IAlbumsLibraryData { // TODO get from remote
        return {
            id: 'devLib',
            categories: [LocalizationContents.getText('garden'), LocalizationContents.getText('sweets')],
            pictures: catalog_json.pictures.map((item) => {
                return item;
            }),
            albums: catalog_json.albums.map((item) => {
                return item;
            }),
        };
    }

    public getUserData(): IUserData {
        return {
            id: 'id',
            name: 'Player_1',
            balance: {
                livesCount: 6,
                livesTimestamp: 0,
                unlimLivesPeriod: 0,
                unlimLivesTimestamp: 0,
                coins: 100,
                needleBoosterCount: 3,
                brushBoosterCount: 3,
                hookBoosterCount: 3,
            },
            friends: [],
            albums: ['gloria'],
            progress: [],
        };
    }
}
